import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsIncarnated, useIsAdmin } from '../auth/hooks';
import { useIsLoggedIn, useAuthLoading } from '../auth/hooks';
import { useRefetchOnAuthChange } from '../auth/hooks';
import { useFeatures } from '../settings/hooks';
import { useDashboard } from './hooks';
import CreateCourseModel from '../course/components/CreateCourseModel';
import DashboardContentOld from './DashboardContentOld';
import DashboardContent from './DashboardContent';
import OwnerDashboard from './components/OwnerDashboard';

const Dashboard = () => {
  const features = useFeatures();
  const isIncarnated = useIsIncarnated();
  const isLoggedIn = useIsLoggedIn();
  const { isAuthLoading } = useAuthLoading();
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();

  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortMode, setSortMode] = useState(false);

  const showBiDashboard = features?.biDashboard && (isAdmin || isIncarnated);
  const showNewDashboard = features?.newDashboard;

  // Fetch dashboard data
  const {
    dashboardData,
    isLoading: isLoadingQ,
    refetch,
    isUninitialized,
  } = useDashboard(
    {
      sortBy: sortMode ? 'created' : 'lastVisit',
      filters: [{ mode: 'name', value: searchQuery }],
    },
    {
      skip: !isLoggedIn || isAuthLoading,
    },
  );

  const isLoading = isAuthLoading || isLoadingQ;

  // Refetch on auth changes
  const canRefetch = isLoggedIn && !isAuthLoading && !isUninitialized;
  useRefetchOnAuthChange(refetch, { enabled: canRefetch });

  useEffect(() => {
    if (isLoggedIn && !isAuthLoading && !isUninitialized) {
      refetch && refetch();
    }
  }, [searchQuery, sortMode, isLoggedIn, isAuthLoading, isUninitialized, refetch, isIncarnated]);

  const openModal = () => setIsModalOpen(true);

  const closeModal = () => setIsModalOpen(false);

  const clearSearch = useCallback(() => {
    setSearchQuery('');
  }, []);

  const handleSearch = useCallback((value) => {
    setSearchQuery(value);
  }, []);

  const handleCourseCreated = useCallback(
    (data) => {
      if (data) {
        navigate(`/courses/${data.id}/settings`);
      }
    },
    [navigate],
  );

  return (
    <>
      {showBiDashboard ? (
        <OwnerDashboard dashboardData={dashboardData} searchQuery={searchQuery} isLoading={isLoading} />
      ) : showNewDashboard ? (
        <DashboardContent
          handleSearch={handleSearch}
          searchQuery={searchQuery}
          clearSearch={clearSearch}
          dashboardData={dashboardData}
          isLoading={isLoading}
        />
      ) : (
        <DashboardContentOld
          openModal={openModal}
          setSortMode={setSortMode}
          handleSearch={handleSearch}
          searchQuery={searchQuery}
          clearSearch={clearSearch}
          dashboardData={dashboardData}
          isLoading={isLoading}
        />
      )}

      <CreateCourseModel open={isModalOpen} onClose={closeModal} onSuccess={handleCourseCreated} />
    </>
  );
};

export default Dashboard;
